export default class Account {
  id: string;
  accountName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  phoneNumber: string;
  website: string;
  logo: string;
  i9ServiceStatus: string;
  i9GoLiveDate: Date;
  i9DeactivationDate: Date;
  vtAccountStatus: string;
  accountManagerEmail: string;
  accountManagerFirstName: string;
  accountManagerLastName: string;
  accountManagerPhone: string;
  salesForceAccountId?: string;

  constructor(
    id: string,
    accountName: string,
    address1: string,
    address2: string,
    city: string,
    state: string,
    zipCode: string,
    phoneNumber: string,
    website: string,
    logo: string,
    i9ServiceStatus: string,
    i9GoLiveDate: Date,
    i9DeactivationDate: Date,
    vtAccountStatus: string,
    accountManagerEmail: string,
    accountManagerFirstName: string,
    accountManagerLastName: string,
    accountManagerPhone: string,
    salesForceAccountId: string
  ) {
    this.id = id;
    this.accountName = accountName;
    this.address1 = address1;
    this.address2 = address2;
    this.city = city;
    this.state = state;
    this.zipCode = zipCode;
    this.phoneNumber = phoneNumber;
    this.website = website;
    this.logo = logo;
    this.i9ServiceStatus = i9ServiceStatus;
    this.i9GoLiveDate = i9GoLiveDate;
    this.i9DeactivationDate = i9DeactivationDate;
    this.vtAccountStatus = vtAccountStatus;
    this.accountManagerEmail = accountManagerEmail;
    this.accountManagerFirstName = accountManagerFirstName;
    this.accountManagerLastName = accountManagerLastName;
    this.accountManagerPhone = accountManagerPhone;
    this.salesForceAccountId = salesForceAccountId;
  }
}
